import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { USAuthenticationGuard } from 'src/app/shared/guard/user-auth-guard';
import { MakePaymentLayoutComponent } from './layouts/make-payment-layout/make-payment-layout.component';
import { AboutUsPageComponent } from './pages/about-us-page/about-us-page.component';
import { BlogDetailsPageComponent } from './pages/blog-page/blog-details-page/blog-details-page.component';
import { BlogPageComponent } from './pages/blog-page/blog-page.component';
import { CareerPageComponent } from './pages/career-page/career-page.component';
import { CartPageComponent } from './pages/cart-page/cart-page.component';
import { CompanyDetailsPageComponent } from './pages/company-details-page/company-details-page.component';
import { CompanyListPageComponent } from './pages/company-list-page/company-list-page.component';
import { CompanySampleReportPageComponent } from './pages/company-sample-report-page/company-sample-report-page.component';
import { ContactUsPageComponent } from './pages/contact-us-page/contact-us-page.component';
import { FeedDetailsPageComponent } from './pages/feed-details-page/feed-details-page.component';
import { FeedsDetailsPageComponent } from './pages/feeds-details-page/feeds-details-page.component';
import { IndustryReportPageComponent } from './pages/industry-report-page/industry-report-page.component';
import { MicroProductDetailsPageComponent } from './pages/micro-product-details-page/micro-product-details-page.component';
import { MicroProductPageComponent } from './pages/micro-product-page/micro-product-page.component';
import { MonetizingGatewayPageComponent } from './pages/monetizing-gateway-page/monetizing-gateway-page.component';
import { NotificationPageComponent } from './pages/notification-page/notification-page.component';
import { PartnersPageComponent } from './pages/partners-page/partners-page.component';
import { PricePageComponent } from './pages/price-page/price-page.component';
import { PrivacyPolicyPageComponent } from './pages/privacy-policy-page/privacy-policy-page.component';
import { ProfilePageComponent } from './pages/profile-page/profile-page.component';
import { RefundPolicyPageComponent } from './pages/refund-policy-page/refund-policy-page.component';
import { SearchCompanyListPageComponent } from './pages/search-company-list-page/search-company-list-page.component';
import { TeamPageComponent } from './pages/team-page/team-page.component';
import { TermsAndConditionsPageComponent } from './pages/terms-and-conditions-page/terms-and-conditions-page.component';
import { TransactionPageComponent } from './pages/transaction-page/transaction-page.component';
import { ReportSubscriptionComponent } from './pages/report-subscription/report-subscription.component';
import { CustomerDemandComponent } from './pages/customer-demand/customer-demand.component';
import { FeedProboDetailsComponent } from './components/feed-probo-details/feed-probo-details.component';
import { DownloadFinancialReportComponent } from './pages/download-financial-report/download-financial-report.component';
import { ProfileNavPageComponent } from './pages/profile-page/profile-nav-page/profile-nav-page.component';
import { FinancialReportPageComponent } from './pages/financial-report-page/financial-report-page.component';
import { MoreOptionsComponent } from './pages/more-options/more-options.component';

const routes: Routes = [
  {
    path: 'feed',
    component: FeedsDetailsPageComponent,
  },
  {
    path: 'feed/details/:id',
    component: FeedDetailsPageComponent,
  },
  {
    path: 'feed/bharat/:id',
    component: FeedProboDetailsComponent,
  },
  {
    path: 'company/search',
    component: SearchCompanyListPageComponent,
  },
  {
    path: 'company',
    component: CompanyListPageComponent,
  },
  // {
  //   path: 'company',
  //   redirectTo: 'company',
  // },
  {
    path: 'company/:name',
    redirectTo: 'company/:name/overview',
  },
  {
    path: 'company/:name/:tab',
    component: CompanyDetailsPageComponent,
  },
  {
    path: 'company/:name/product/:report/:sku/:isReportVisible',
    component: IndustryReportPageComponent,
  },
  // {
  //   path: 'compare',
  //   canActivate: [USAuthenticationGuard],
  //   component: CompanreCompanyPageComponent
  // },
  {
    path: 'company/:name/sample/:report/:sku/:isSampleReportVisible',
    component: CompanySampleReportPageComponent,
  },
  {
    path: 'reports',
    component: MicroProductPageComponent,
  },
  {
    path: 'reports/details/:report_url',
    component: MicroProductDetailsPageComponent,
  },
  {
    path: 'report/subscription',
    component: ReportSubscriptionComponent,
  },
  {
    path: 'customised/report',
    component: CustomerDemandComponent,
  },
  {
    path: 'prices',
    component: PricePageComponent,
  },
  {
    path: 'about-us',
    component: AboutUsPageComponent,
  },
  {
    path: 'account',
    canActivate: [USAuthenticationGuard],
    component: ProfileNavPageComponent,
  },
  {
    path: 'more',
    component: MoreOptionsComponent,
  },
  // {
  //   path: 'account',
  //   redirectTo: '/account/profile',
  //   pathMatch: 'full'
  // },
  {
    path: 'account/profile',
    canActivate: [USAuthenticationGuard],
    component: ProfilePageComponent,
  },
  {
    path: 'account/profile/change-password',
    canActivate: [USAuthenticationGuard],
    component: ProfilePageComponent,
    // ChangePasswordComponent
  },
  {
    path: 'account/transaction',
    canActivate: [USAuthenticationGuard],
    component: ProfilePageComponent,
  },
  {
    path: 'account/my-request',
    canActivate: [USAuthenticationGuard],
    component: ProfilePageComponent,
  },
  {
    path: 'account/following',
    canActivate: [USAuthenticationGuard],
    component: ProfilePageComponent,
  },
  {
    path: 'account/probo',
    canActivate: [USAuthenticationGuard],
    component: ProfilePageComponent,
  },
  {
    path: 'account/posts',
    canActivate: [USAuthenticationGuard],
    component: ProfilePageComponent,
  },
  {
    path: 'cart',
    component: CartPageComponent,
  },
  {
    path: 'payment/:id',
    component: MakePaymentLayoutComponent,
  },
  {
    path: 'account/transaction/:id',
    component: TransactionPageComponent,
  },
  {
    path: 'terms-and-conditions',
    component: TermsAndConditionsPageComponent,
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyPageComponent,
  },
  {
    path: 'contact-us',
    component: ContactUsPageComponent,
  },
  {
    path: 'partners',
    component: PartnersPageComponent,
  },
  {
    path: 'career',
    component: CareerPageComponent,
  },
  {
    path: 'refund-policy',
    component: RefundPolicyPageComponent,
  },
  {
    path: 'monetizing-gateway',
    component: MonetizingGatewayPageComponent,
  },
  {
    path: 'blogs',
    component: BlogPageComponent,
  },
  {
    path: 'blogs/wp-admin/',
    component: BlogPageComponent,
  },
  {
    path: 'blogs/category/:category',
    component: BlogPageComponent,
  },
  {
    path: 'blogs/:slug',
    component: BlogDetailsPageComponent,
  },
  {
    path: 'team',
    component: TeamPageComponent,
  },
  {
    path: 'notification',
    canActivate: [USAuthenticationGuard],
    component: NotificationPageComponent,
  },
  {
    path: 'financial',
    component: FinancialReportPageComponent,
  },
  {
    path: 'financial/report',
    component: DownloadFinancialReportComponent,
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerRoutingModule { }
